import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=0bca779e&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
import style0 from "./Videos.vue?vue&type=style&index=0&id=0bca779e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca779e",
  null
  
)

export default component.exports